import { JDSFeedbackBlockProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSFeedbackBlockProps>
  ): React.FC<JDSFeedbackBlockProps> =>
  (props: JDSFeedbackBlockProps) => {
    if (!props.stateText) return null;
    return <Component {...props} />;
  };
